/**
 * OIDC 特殊路由检测工具
 * 用于识别不应触发认证重定向的特殊页面
 */

/**
 * OIDC 特殊路由白名单
 * 这些路由正在处理 OIDC 流程，不应被 initAuth 打断
 */
const OIDC_SPECIAL_ROUTES = [
  '/callback',           // OIDC 回调页面
  '/callBack',           // 兼容旧路由
  '/silent-renew.html',  // 静默续期页面
  '/env-debug',          // 环境配置调试页面
  '/auth-redirect',      // 认证重定向页面
];

/**
 * 检查当前路由是否为 OIDC 特殊路由
 * @returns true 表示当前正在处理 OIDC 流程，应跳过 initAuth 的认证检查
 */
export const isOidcSpecialRoute = (): boolean => {
  const pathname = window.location.pathname;
  const searchParams = new URLSearchParams(window.location.search);

  // 1. 检查路径是否在白名单中
  if (OIDC_SPECIAL_ROUTES.includes(pathname)) {
    
    return true;
  }

  // 2. 检查是否包含 OIDC 回调参数 (code, state)
  // 这种情况下可能是 IdP 重定向回来但路由配置不标准
  if (searchParams.has('code') && searchParams.has('state')) {
    
    return true;
  }

  return false;
};

/**
 * 检查当前是否应该跳过 SSO 认证（开发模式）
 * @returns true 表示跳过 SSO，使用开发 token
 */
export const shouldSkipSSO = (): boolean => {
  return import.meta.env.VITE_SKIP_SSO === 'true';
};
